module.exports = __webpack_public_path__ + "static/media/Campton-Book.3e712bfd.woff";